import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import DisableTransitionOnChange from './DisableTransitionOnChange';
import ClientProvider from './client';
export default createDemo(import.meta.url, DisableTransitionOnChange, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/css-theme-variables/demos/disable-transition-on-change/DisableTransitionOnChange.tsx",
    "fileName": "DisableTransitionOnChange.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { createTheme, ThemeProvider, useColorScheme } from '@mui/material/styles';\nimport Stack from '@mui/material/Stack';\nimport MenuItem from '@mui/material/MenuItem';\nimport Switch from '@mui/material/Switch';\nimport Select from '@mui/material/Select';\nimport FormControlLabel from '@mui/material/FormControlLabel';\n\nconst theme = createTheme({\n  cssVariables: {\n    colorSchemeSelector: '.demo-disable-transition-%s',\n  },\n  colorSchemes: { dark: true },\n});\n\nfunction ModeSwitcher() {\n  const { mode, setMode } = useColorScheme();\n  if (!mode) {\n    return null;\n  }\n  return (\n    <Select\n      value={mode}\n      onChange={(event) =>\n        setMode(event.target.value as 'system' | 'light' | 'dark')\n      }\n      sx={{ minWidth: 120 }}\n    >\n      <MenuItem value=\"system\">System</MenuItem>\n      <MenuItem value=\"light\">Light</MenuItem>\n      <MenuItem value=\"dark\">Dark</MenuItem>\n    </Select>\n  );\n}\n\nexport default function DisableTransitionOnChange() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 1,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [disableTransition, setDisableTransition] = React.useState(false);\n  return (\n    <ThemeProvider\n      theme={theme}\n      disableNestedContext\n      disableTransitionOnChange={disableTransition}\n    >\n      <Stack\n        sx={{\n          width: '100%',\n          borderRadius: '4px',\n          p: 2,\n          gap: 2,\n          display: 'flex',\n          justifyContent: 'center',\n          alignItems: 'center',\n          bgcolor: 'background.default',\n          color: 'text.primary',\n          transition: '1s',\n        }}\n      >\n        <ModeSwitcher />\n        <FormControlLabel\n          control={\n            <Switch\n              checked={disableTransition}\n              onChange={(event) => setDisableTransition(event.target.checked)}\n            />\n          }\n          label=\"Disable transition\"\n        />\n      </Stack>\n    </ThemeProvider>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 71,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { createTheme, ThemeProvider, useColorScheme } from '@mui/material/styles';\nimport Stack from '@mui/material/Stack';\nimport MenuItem from '@mui/material/MenuItem';\nimport Switch from '@mui/material/Switch';\nimport Select from '@mui/material/Select';\nimport FormControlLabel from '@mui/material/FormControlLabel';\n\nconst theme = createTheme({\n  cssVariables: {\n    colorSchemeSelector: '.demo-disable-transition-%s',\n  },\n  colorSchemes: { dark: true },\n});\n\nfunction ModeSwitcher() {\n  const { mode, setMode } = useColorScheme();\n  if (!mode) {\n    return null;\n  }\n  return (\n    <Select\n      value={mode}\n      onChange={(event) =>\n        setMode(event.target.value as 'system' | 'light' | 'dark')\n      }\n      sx={{ minWidth: 120 }}\n    >\n      <MenuItem value=\"system\">System</MenuItem>\n      <MenuItem value=\"light\">Light</MenuItem>\n      <MenuItem value=\"dark\">Dark</MenuItem>\n    </Select>\n  );\n}\n\nexport default function DisableTransitionOnChange() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 1
        },
        "  const [disableTransition, setDisableTransition] = React.useState(false);\n  return (\n    <ThemeProvider\n      theme={theme}\n      disableNestedContext\n      disableTransitionOnChange={disableTransition}\n    >\n      <Stack\n        sx={{\n          width: '100%',\n          borderRadius: '4px',\n          p: 2,\n          gap: 2,\n          display: 'flex',\n          justifyContent: 'center',\n          alignItems: 'center',\n          bgcolor: 'background.default',\n          color: 'text.primary',\n          transition: '1s',\n        }}\n      >\n        <ModeSwitcher />\n        <FormControlLabel\n          control={\n            <Switch\n              checked={disableTransition}\n              onChange={(event) => setDisableTransition(event.target.checked)}\n            />\n          }\n          label=\"Disable transition\"\n        />\n      </Stack>\n    </ThemeProvider>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 71,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/styles",
      "@mui/material/Stack",
      "@mui/material/MenuItem",
      "@mui/material/Switch",
      "@mui/material/Select",
      "@mui/material/FormControlLabel"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
